// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import Header from "../header/HeaderComponent"
import Footer from "../footer/FooterComponent"
import Seo from "../Seo/SeoComponent"
import styles from "./releasesInfoPage.module.scss"
import PageLanguageLink from "../PageLanguageLink/PageLanguageLink";

function ReleasesInfoPage() {
    const { t, i18n } = useTranslation("releasesInfoPage")
    const isPt = i18n.language === "pt"
    const switchPath = isPt ? "/releases" : "/pt/releases"
    const currentPath = isPt ? "/pt/releases" : "/releases"
    const releases = t("releases", { returnObjects: true })
    const [areOlderReleasesVisible, setAreOlderReleasesVisible] = useState(false)
    const visibleReleases = areOlderReleasesVisible ? releases : releases.slice(0, 1)
    const hasOlderReleases = releases.length > 1

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>{t("title")}</h1>
                    <p className={styles.description}>{t("description")}</p>

                    {visibleReleases.map((release) => (
                        <div
                            key={release.version}
                            className={release.badge ? `${styles.card} ${styles.currentCard}` : styles.card}
                        >
                            <div className={styles.cardHeader}>
                                <div>
                                    <p className={styles.releaseLabel}>{release.label}</p>
                                    <h2 className={styles.cardTitle}>{t("versionLabel", { version: release.version })}</h2>
                                </div>
                                {release.badge && (
                                    <span className={styles.currentBadge}>{release.badge}</span>
                                )}
                            </div>
                            <p className={styles.cardText}>{release.text}</p>
                            <h3 className={styles.sectionTitle}>{release.sectionTitle}</h3>
                            <ul className={styles.featureList}>
                                {release.features.map((feature) => (
                                    <li key={feature}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    {hasOlderReleases && (
                        <button
                            type="button"
                            className={styles.olderReleasesToggle}
                            onClick={() => setAreOlderReleasesVisible((visible) => !visible)}
                            aria-expanded={areOlderReleasesVisible}
                        >
                            {areOlderReleasesVisible ? t("hideOlder") : t("showOlder")}
                        </button>
                    )}

                    <PageLanguageLink to={switchPath} />
                </section>
            </main>

            <Footer />
        </div>
    )
}

export default ReleasesInfoPage
